import { Suspense, lazy } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { common } from '@ocean/ui'
import { MobileNativeUtils } from 'utils'
import authRoutes from 'modules/Auth/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const MobileNativeRedirect = lazy(
  () =>
    import(
      /* webpackChunkName: "MobileNativeRedirect" */ 'modules/redirects/MobileNativeRedirect/pages/MobileNativeRedirect'
    )
)

const RedirectComponent = () => {
  const isOceanUserAgent = MobileNativeUtils.checkOceanLearningAppUserAgent()
  if (!isOceanUserAgent) return <Redirect to={authRoutes.login} />
  return <MobileNativeRedirect />
}

const MobileNativeRedirectRouting = () => {
  return (
    <Suspense fallback={<RouteChangeProgress />}>
      <Switch>
        <Route exact path={routes.root} component={RedirectComponent} />
      </Switch>
    </Suspense>
  )
}

export default MobileNativeRedirectRouting
